module.exports = "<p>herdeiro-details works!</p>\r\n"